import * as React from 'react';
import Link from 'next/link';

import type { Banner } from '@nutralab/api';
import { Text } from '@nutralab/ui';

import styles from './BannerCard.module.scss';

import { getImageUrl, isExternalLink } from '@/shared/utils';

interface BannerCardProps {
    banner: Banner;
    onNavigate: () => void;
}

/** One banner in the notifications popover; an external link opens in a new tab. */
export function BannerCard({ banner, onNavigate }: BannerCardProps): React.ReactElement {
    const content = (
        <>
            {banner.image && (
                <img src={getImageUrl(banner.image)} alt={banner.title} className={styles.image} loading="lazy" />
            )}
            <div className={styles.body}>
                <Text weight="medium" size="lg">
                    {banner.title}
                </Text>
                <Text color="muted">{banner.text}</Text>
            </div>
        </>
    );

    if (!banner.link) {
        return <div className={styles.card}>{content}</div>;
    }

    if (isExternalLink(banner.link)) {
        return (
            <a
                href={banner.link}
                target="_blank"
                rel="noopener noreferrer"
                className={styles.card}
                onClick={onNavigate}
            >
                {content}
            </a>
        );
    }

    return (
        <Link href={banner.link} className={styles.card} onClick={onNavigate}>
            {content}
        </Link>
    );
}
